import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Houston from "../../images/contact/Houston.svg";
import SanFrancisco from "../../images/contact/San-Francisco.svg";
import Miami from "../../images/contact/Miami.svg";
import NewYork from "../../images/contact/new-york.svg";
import Washington from "../../images/contact/Washington.svg";
import Dubai from "../../images/contact/Dubai.svg";
import Karachi from "../../images/contact/Karachi.svg";
import Chicago from "../../images/contact/Chicago.svg";
import Dallas from "../../images/contact/Dallas.svg";
import Saudia from "../../images/contact/saudia.svg";
import Bahrain from "../../images/contact/bahrain.svg";
import Qatar from "../../images/contact/qatar.svg";

const data = [
  {
    title: "Houston",
    address: "4201 Main St STE 200, Houston, TX 77002",
    link: "https://goo.gl/maps/LdQJEaYGLexPhxvb9",
    image: Houston,
  },
  {
    title: "San Francisco",
    address: "44 Tehama St, San Francisco, CA 94105",
    link: "https://goo.gl/maps/ZkcfVHN1Fgs9zDqW8",
    image: SanFrancisco,
  },
  {
    title: "New York",
    address: "510 5th Ave 3rd Floor, New York, NY 10036",
    link: "https://goo.gl/maps/ZkcfVHN1Fgs9zDqW8",
    image: NewYork,
  },
  {
    title: "Miami",
    address: "400 NW 26th St, Miami, FL 33127",
    link: "https://goo.gl/maps/5CidutEg7uEmYQGB7",
    image: Miami,
  },
  {
    title: "Washington",
    address: "740 15th St NW 8th Floor, Washington, DC, 20005",
    link: "https://g.page/r/CVRxHz9ggqrBEBA",
    image: Washington,
  },
  {
    title: "Dubai",
    address:
      "Sheikh Rashid Tower, Floor No. 19, Dubai World Trade Center, Dubai, United Arab Emirates",
    link: "https://goo.gl/maps/mebXx8yQd6nt31v77",
    image: Dubai,
  },
  {
    title: "Karachi",
    address: "5FI 3, 2nd Floor, Block 3, Gulshan-e-Iqbal, Karachi",
    link: "https://goo.gl/maps/c2tuPVftxtZHzLgB7",
    image: Karachi,
  },
  {
    title: "Dallas",
    address: "14555 Dallas Pkwy STE 100-227, Dallas, TX 75254, United States",
    link: "https://goo.gl/maps/eYXi9mYW1zky1Hyo8",
    image: Dallas,
  },
  {
    title: "Chicago",
    address:
      "222 W Merchandise Mart Plaza Floor 12, Suite 1212, Chicago, IL 60654",
    link: "https://goo.gl/maps/YXDsXcSmgDYNwTYm9",
    image: Chicago,
  },
  {
    title: "Saudi Arabia",
    address:
      "Ash Shaikh Abdullah Al Anqari, King Salman Neighborhood, Riyadh 12434, Saudi Arabia",
    link: "https://maps.app.goo.gl/in4GxFfWWtB1D1bR7",
    image: Saudia,
  },
  {
    title: "Bahrain",
    address:
      "West Tower, Bahrain Financial Harbour, Level 22, King Faisal Hwy, Manama 746, Bahrain",
    link: "https://goo.gl/maps/1QuUt2L4yYRThWiVA",
    image: Bahrain,
  },
  {
    title: "Qatar",
    address: "Tornado Tower, Level 22, Doha, Qatar",
    link: "https://goo.gl/maps/7bLnXYi1scnskq2x5",
    image: Qatar,
  },
];

function TekLocation() {
  return (
    <div className="tekrevol_location">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="loaction_box">
              {data?.map((item, i) => (
                <div className="location_item" key={i}>
                  <h4>{item.title}</h4>
                  <LazyLoadImage
                    src={item.image}
                    effect="blur"
                    alt="Image"
                    className="img-fluid"
                  />
                  <div className="addr">{item.address}</div>
                  <Link to={item.link} target="_blank" rel="noopener">
                    View Location
                  </Link>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TekLocation;
